import { useEffect } from "react";
import { useSocket } from "../hooks/useSocket";

export const useLiveLocation = (locationEnable, shopId) => {
  
  const { connected, onMessage, sendMessage, offMessage } = useSocket({
    isSocketConnectionTry: locationEnable,
  });


  useEffect(() => {
    if (!connected) return;

    const handleAck = (res) => {
      if (res.event === "UPDATE_SHOP_LOCATION") {
        console.log("ACK:", res);
      }
    };

    onMessage("ACK", handleAck);

    return () => offMessage("ACK");
  }, [connected]);



  useEffect(() => {
    if (!locationEnable || !connected) return;

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const latitude = pos.coords.latitude;
        const longitude = pos.coords.longitude;

        console.log("Initial:", latitude, longitude);

        sendMessage("UPDATE_SHOP_LOCATION", {
          shopId,
          latitude,
          longitude,
        });
      },
      (err) => console.log("Initial Err:", err),
      {
        enableHighAccuracy: true,
        timeout: 15000,
        maximumAge: 0,
      }
    );
  }, [locationEnable, connected]);


  useEffect(() => {
    if (!locationEnable || !connected) return;

    let watchId = navigator.geolocation.watchPosition(
      (pos) => {
        const lat = pos.coords.latitude;
        const lng = pos.coords.longitude;

        console.log("Live:", lat, lng);

        sendMessage("UPDATE_SHOP_LOCATION", {
          shopId,
          latitude: lat,
          longitude: lng,
        });
      },
      (err) => console.log("Live Err:", err),
      {
        enableHighAccuracy: true,
        timeout: 15000,
        maximumAge: 0,
      }
    );

    return () => {
      if (watchId) navigator.geolocation.clearWatch(watchId);
    };
  }, [locationEnable, connected]);
};
